module.exports = __webpack_public_path__ + "img/icon_home_03.8056182c.png";